import styled from "styled-components";
import Box from './Box'

const ResultContainer = styled(Box)`
    width: 100%;
    &:first-child {
        padding-bottom: 20px;
    }
`

export default ResultContainer